import { Icon } from '@chakra-ui/react';

const PCSiteLogoIcon = (props) => (
	<Icon
		version="1.1"
		id="Layer_1"
		x="0px"
		y="0px"
		viewBox="0 0 30 30"
		fill={'#4A5668'}
		// style="enable-background:new 0 0 1500 1500;"
		{...props}>

		<g>
			<path class="st0" d="M0.87,29.41c-0.22-0.13-0.29-0.31-0.29-0.56c0.01-0.68,0-1.35,0.01-2.03c0-0.36,0.15-0.5,0.51-0.51
		c0.19,0,0.39,0,0.6,0c0-3.38,0-6.74,0-10.11c-0.03-0.01-0.06-0.02-0.1-0.03c-0.59-0.03-0.66-0.11-0.66-0.71
		c0-0.34,0.01-0.68,0-1.01c-0.02-0.48,0.2-0.71,0.62-0.64c0.04,0.01,0.09-0.01,0.14-0.01c0-3.37,0-6.73,0-10.12
		c-0.21,0-0.42,0-0.63,0C0.74,3.68,0.6,3.53,0.59,3.2c0-0.71,0-1.43,0-2.14c0-0.31,0.15-0.47,0.47-0.47c0.72,0,1.44,0,2.17,0
		c0.31,0,0.45,0.16,0.46,0.47c0,0.2,0.01,0.39,0.01,0.59c0,0.01,0.01,0.02,0.03,0.06c0.29,0,0.59,0,0.9,0c0.46,0,0.92,0,1.38,0
		c0.27,0,0.44,0.17,0.44,0.41C6.45,2.38,6.28,2.56,6,2.56c-0.76,0-1.52,0-2.31,0c0,0.23,0,0.44,0,0.65
		C3.68,3.53,3.53,3.68,3.22,3.69c-0.1,0-0.21,0-0.31,0c-0.1,0-0.21,0-0.33,0c0,3.37,0,6.73,0,10.1c0.02,0.01,0.04,0.03,0.06,0.03
		c0.53-0.07,0.72,0.17,0.69,0.72c-0.02,0.34,0,0.68,0,1.01c0,0.51-0.12,0.63-0.62,0.64c-0.04,0-0.07,0-0.13,0.01
		c0,3.36,0,6.73,0,10.12c0.21,0,0.42,0,0.63,0c0.32,0.01,0.47,0.15,0.47,0.46c0,0.21,0,0.41,0,0.64c3.37,0,6.73,0,10.1,0
		c0.01-0.01,0.03-0.04,0.03-0.06c-0.07-0.52,0.15-0.72,0.72-0.69c0.34,0.02,0.68,0,1.01,0c0.52,0,0.63,0.11,0.64,0.62
		c0,0.04,0,0.07,0.01,0.15c0.1,0,0.2,0,0.3,0c1.89,0,3.77,0,5.66,0c0.3,0,0.48,0.13,0.51,0.37c0.03,0.27-0.16,0.47-0.47,0.47
		c-0.92,0-1.84,0-2.76,0c-1.07,0-2.14,0-3.22,0c-0.01,0.04-0.03,0.08-0.03,0.11c0.07,0.48-0.17,0.7-0.68,0.67c-0.3-0.02-0.6,0-0.9,0
		c-0.69,0-0.76-0.06-0.79-0.75c-3.36,0-6.72,0-10.1,0c-0.12,0.35,0.17,0.84-0.31,1.1C2.56,29.41,1.72,29.41,0.87,29.41z M1.45,1.44
		c0,0.48,0,0.93,0,1.38c0.47,0,0.92,0,1.37,0c0-0.47,0-0.93,0-1.38C2.36,1.44,1.92,1.44,1.45,1.44z M2.83,28.55
		c0-0.47,0-0.92,0-1.37c-0.47,0-0.93,0-1.38,0c0,0.47,0,0.91,0,1.37C1.91,28.55,2.36,28.55,2.83,28.55z M2.45,14.69
		c-0.23,0-0.43,0-0.62,0c0,0.22,0,0.43,0,0.64c0.21,0,0.41,0,0.62,0C2.45,15.1,2.45,14.9,2.45,14.69z M15.33,27.56
		c-0.23,0-0.44,0-0.64,0c0,0.22,0,0.42,0,0.62c0.22,0,0.43,0,0.64,0C15.33,27.97,15.33,27.78,15.33,27.56z"/>
			<path class="st0" d="M26.6,29.41c-0.22-0.13-0.31-0.31-0.28-0.56c0.02-0.18,0-0.35,0-0.56c-0.59,0-1.16,0-1.73,0
		c-0.13,0-0.26,0.01-0.39,0c-0.24-0.01-0.41-0.18-0.41-0.41c0-0.24,0.17-0.42,0.42-0.43c0.62-0.01,1.24,0,1.86,0
		c0.07,0,0.15,0,0.25,0c0-0.23,0-0.45,0-0.66c0.01-0.31,0.16-0.46,0.47-0.47c0.2,0,0.39,0,0.59-0.01c0.01,0,0.02-0.01,0.05-0.02
		c0-3.35,0-6.72,0-10.08c-0.02-0.01-0.03-0.03-0.05-0.03c-0.64-0.03-0.71-0.1-0.71-0.75c0-0.32,0-0.64,0-0.96
		c0-0.54,0.1-0.65,0.63-0.66c0.04,0,0.07-0.01,0.13-0.01c0-3.37,0-6.73,0-10.12c-0.22,0-0.43,0-0.64,0
		c-0.31-0.01-0.46-0.16-0.46-0.47c0-0.21,0-0.41,0-0.63c-3.38,0-6.74,0-10.1,0c-0.01,0.02-0.03,0.03-0.03,0.05
		c-0.03,0.64-0.1,0.71-0.76,0.71c-0.33,0-0.66,0-0.98,0c-0.49,0-0.62-0.12-0.63-0.6c0-0.05-0.01-0.09-0.01-0.17
		c-0.11,0-0.21,0-0.31,0c-1.79,0-3.58,0-5.38,0c-0.31,0-0.49-0.16-0.5-0.41C7.63,1.88,7.82,1.72,8.14,1.72c0.07,0,0.13,0,0.2,0
		c1.72,0,3.43,0,5.15,0c0.1,0,0.2,0,0.29,0c0.02-0.04,0.03-0.05,0.03-0.07c0.03-0.63,0.1-0.7,0.73-0.7c0.34,0,0.68,0,1.01,0
		c0.5,0,0.61,0.11,0.62,0.6c0,0.05,0.01,0.09,0.01,0.15c3.37,0,6.73,0,10.12,0c0-0.22,0-0.44,0-0.65c0.01-0.3,0.16-0.46,0.45-0.46
		c0.73-0.01,1.46-0.02,2.19,0.01c0.15,0.01,0.3,0.17,0.45,0.27c0,0.84,0,1.69,0,2.53c-0.26,0.48-0.75,0.18-1.11,0.31
		c0,3.37,0,6.73,0,10.1c0.06,0,0.09,0.01,0.13,0.01c0.51,0.01,0.62,0.13,0.62,0.63c0,0.33,0,0.66,0,0.98c0,0.65-0.06,0.72-0.71,0.75
		c-0.02,0-0.03,0.02-0.05,0.03c0,3.36,0,6.72,0,10.1c0.19,0,0.37,0.01,0.55,0c0.25-0.02,0.44,0.07,0.56,0.28c0,0.94,0,1.88,0,2.81
		C28.47,29.41,27.54,29.41,26.6,29.41z M27.17,2.83c0.48,0,0.93,0,1.38,0c0-0.47,0-0.92,0-1.37c-0.47,0-0.92,0-1.38,0
		C27.17,1.92,27.17,2.37,27.17,2.83z M27.18,27.17c0,0.48,0,0.93,0,1.38c0.47,0,0.92,0,1.37,0c0-0.47,0-0.93,0-1.38
		C28.08,27.17,27.64,27.17,27.18,27.17z M15.33,1.84c-0.23,0-0.43,0-0.64,0c0,0.22,0,0.42,0,0.62c0.22,0,0.43,0,0.64,0
		C15.33,2.25,15.33,2.06,15.33,1.84z M28.17,15.33c0-0.23,0-0.44,0-0.65c-0.21,0-0.41,0-0.61,0c0,0.22,0,0.43,0,0.65
		C27.76,15.33,27.95,15.33,28.17,15.33z"/>
			<g>
				<path class="st0" d="M6.1,13.19v-1.56H5.63v-1.26h2.24v1.26H7.38v1.56H6.1z M8.66,15.66h1.25v2.25H5.63v-1.26H6.1v-1.57h1.29v1.56
			h1.27V15.66z M7.38,14.7v-1.13H6.1v1.13H7.38z"/>
				<polygon class="st0" points="13.96,10.37 11.57,10.37 10.6,11.34 10.6,13.12 11.87,13.12 11.87,11.64 13.67,11.64 13.67,16.64 
			11.87,16.64 11.87,15.14 10.6,15.14 10.6,16.94 11.57,17.9 13.96,17.9 14.92,16.94 14.92,11.34 		"/>
				<rect x="10.6" y="13.5" class="st0" width="1.26" height="1.26" />
				<path class="st0" d="M18.99,10.36l0.97,0.97v1.28H18.7v-0.98h-1.8v1.48h-1.26v-1.78l0.97-0.97H18.99z M16.9,14.75v-1.26h-1.26
			v1.26H16.9z M17.98,14.76V13.5h1.98v3.43l-0.97,0.97h-2.39l-0.97-0.97v-1.8h1.26v1.51h1.8v-1.88H17.98z"/>
				<polygon class="st0" points="24.01,10.37 21.62,10.37 20.66,11.34 20.66,13.12 21.92,13.12 21.92,11.64 23.72,11.64 23.72,16.64 
			21.92,16.64 21.92,15.14 20.66,15.14 20.66,16.94 21.62,17.9 24.01,17.9 24.98,16.94 24.98,11.34 		"/>
				<rect x="20.66" y="13.5" class="st0" width="1.26" height="1.26" />
			</g>
		</g>

	</Icon>
);

export default PCSiteLogoIcon;
